<template>
  <b-container>
    <b-overlay
      :show="isBusy"
      rounded="sm"
      spinner-type="grow"
      spinner-variant="primary"
    >
      <FilterComponent
        :store="store" 
        :filter="filter"
        @filter-now="filter = '';changePage(1);" 
        @change-page="changePage($event)"
        @add-new="add()"
        @filter-word="filter = $event"
      />
      <b-alert
        show
        variant="danger"
        dismissible
      >
        <strong>Note:</strong> Also available at <a href="https://ssiplengg.com">https://ssiplengg.com</a>.
      </b-alert>
    
      <CrudComponent
        :store.sync="store"
        :filter="filter"
        :fetch="fetchItems"
        :formerr.sync="formError"
        @editNow="edit"
        @showNow="show"
        @delNow="del"
        @changeNow="changePage"
      />
    </b-overlay>

    <!-- Edit modal -->
    <b-modal
      id="modal"
      centered
      :title="form.formTitle"
      hide-footer
    >
      <b-alert 
        v-if="alert.message" 
        :show="5" 
        dismissible 
        :variant="alert.type" 
        @dismissed="clearAlert"
      >
        {{ alert.message }}
      </b-alert>

      <b-form @submit.stop.prevent="onSubmit">
        <b-form-group 
          label="Name" 
          label-cols-sm="4"
          label-cols-lg="3" 
          label-for="name"
        >
          <b-form-input
            id="name"
            v-model="$v.form.item.name.$model"
            name="name"
            :state="validateState('name')"
            aria-describedby="name-live-feedback"
          />

          <b-form-invalid-feedback
            id="name-live-feedback"
          >
            This is a required field and must be at least 3 characters.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group 
          label="Meter Number" 
          label-cols-sm="4"
          label-cols-lg="3" 
          label-for="mnum"
        >
          <b-form-input
            id="mnum"
            v-model="$v.form.item.mnum.$model"
            name="mnum"
            :state="validateState('mnum')"
            aria-describedby="mnum-live-feedback"
          />

          <b-form-invalid-feedback id="mnum-live-feedback">
            This is a required field.
          </b-form-invalid-feedback>
        </b-form-group>
        
        <b-form-group 
          label="Last Reading" 
          label-cols-sm="4"
          label-cols-lg="3" 
          label-for="prev_read"
        >
          <b-form-input
            id="prev_read"
            v-model="$v.form.item.prev_read.$model"
            name="prev_read"
            :state="validateState('prev_read')"
            aria-describedby="prev_read-live-feedback"
          />

          <b-form-invalid-feedback id="prev_read-live-feedback">
            This is a required field.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group 
          label="Last Status" 
          label-cols-sm="4"
          label-cols-lg="3" 
          label-for="prev_status"
        >
          <b-form-select 
            id="prev_status"
            v-model="$v.form.item.prev_status.$model"
            name="prev_status"
            :state="validateState('prev_status')"
            :options="[
              {text: 'Active', value: 1},{text: 'Faulty', value: 0}
            ]"
            aria-describedby="prev_status-live-feedback"
          />

          <b-form-invalid-feedback id="prev_status-live-feedback">
            This is a required field.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group  
          label="Customer:"
          label-cols-sm="4"
          label-cols-lg="3"  
          label-for="user_id"
        >
          <b-form-select 
            v-model="$v.form.item.user_id.$model" 
            :state="validateState('user_id')"
            :options="[{text: 'None', value: null}, ...store.customers]"
          />

          <b-form-invalid-feedback id="prev_status-live-feedback">
            This is a required field.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group  
          label="Prev Date:"
          label-cols-sm="4"
          label-cols-lg="3"  
          label-for="prev_date"
        >
          <b-form-datepicker
            id="prev_date"
            v-model="$v.form.item.prev_date.$model"
            class="mb-2"
            aria-describedby="prev_date-live-feedback"
          />
          <b-form-invalid-feedback id="prev_date-live-feedback">
            This is a required field.
          </b-form-invalid-feedback>
        </b-form-group>

        <div class="text-center">
          <b-button
            type="submit"
            variant="primary"
          >
            Submit
          </b-button>
          <!-- <b-button class="ml-2" @click="resetForm()">Reset</b-button> -->
        </div>
      </b-form>
    </b-modal>

    <!-- Show modal -->
    <b-modal
      id="show-modal"
      centered
      title="Show Item"
      ok-only
      size="md"
    >
      <ul class="list-group">
        <li
          v-for="(val, index) in form.item"
          :key="index"
          class="list-group-item"
        >
          {{ index + ' : ' + JSON.stringify(val, 0, 2) }}
        </li>
      </ul>
    </b-modal>
  </b-container>
</template>

<style scoped>

</style>

<script>
import helper from '@/mixins/helper';
import { mapState, mapActions, mapGetters } from 'vuex';
import { validationMixin } from "vuelidate";
import { required, minLength, numeric } from "vuelidate/lib/validators";
import FilterComponent from '@/components/FilterComponent';
import CrudComponent from '@/components/CrudComponent';

export default {
  name: 'Meters',
  components:{
    FilterComponent,
    CrudComponent
  },
  mixins: [validationMixin, helper],
  data() {
    return {
      form: {
        formTitle: 'Create Item',
        mode: 'add',
        item: {
          id: null,
          name: null,
          mnum: null,
          prev_read: null,
          prev_status: null,
          user_id: null,
          updated_at: null,
        }
      },
      isBusy: false,
      sortBy: '',
      sortDesc: false,
      filter: ''
    }
  },
  computed: {
    ...mapState({ alert: state => state.alert }),
    ...mapState("meter", ['formError']),
    ...mapGetters("meter", ['store'])
  },
  validations: {
    form: {
      item: {
        name: {
          required,
          minLength: minLength(3)
        },
        mnum: {
          required
        },
        prev_read: {
          numeric,
          required
        },
        prev_status: {
          required
        },
        user_id: { },
        prev_date: { 

        }
      }
    }
  },
  watch: {
    formError(newVal){
      if(!newVal){
        this.$bvModal.hide('modal');
      }
    }
  },
  mounted(){
    this.setCustomers();
  },
  methods: {
    ...mapActions("meter", [
      "fetchItems", 
      "addItem", 
      "deleteItem", 
      "updateItem", 
      "changePage", 
      "setCustomers"
    ]),
    
    // 1. Prepare modal for creation of item.
    add() {
      this.$v.$reset();
      this.form.item = {
        id: null,
        name: null,
        mnum: null,
        prev_read: null,
        prev_status: null,
        user_id: null,
        prev_date: null
      }
      this.form.formTitle = 'Create Item:';
      this.form.mode = 'add';
      this.$root.$emit('bv::show::modal', 'modal')
    },

    // Prepare model for updation.
    edit(item, button) {
      this.form = {
        formTitle: 'Edit Item:',
        mode: 'update',
        item: JSON.parse(JSON.stringify(item))
      };
      this.$root.$emit('bv::show::modal', 'modal', button)
    },

    // 2. Validation after creating form.
    validateState(name) {
      const { $dirty, $error } = this.$v.form.item[name];
      return $dirty ? !$error : null;
    },

    // 3. Handle Submit - Call Store fundtion.
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      if(this.form.mode == 'update'){
        this.clean(this.form.item);
        this.updateItem(this.form.item);
      }else{
        this.addItem(this.form.item);
      }
    },

    // 4. Show Item details in another Modal.
    show(item, index, button) {
      this.form.item = item;
      this.$root.$emit('bv::show::modal', 'show-modal', button)
    },

    // 5. Delete the item.
    del(id) {
      let res = window.confirm("Are you sure?");
      if(res) this.deleteItem(id);
    },
  }
}
</script>
